"use client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Filter } from "lucide-react";
import { useRouter } from "next/navigation";

const Filters = ({ schoolClasses }) => {
  const router = useRouter();
  let queryParams;

  const reset = (name) => {
    if (typeof window !== "undefined") {
      queryParams = new URLSearchParams(window.location.search);
    }

    if (queryParams.has(name)) {
      queryParams.delete(name);
      const newUrl = window.location.pathname + "?" + queryParams.toString();
      router.push(newUrl);

      const checkboxes = document.getElementsByName(name);
      checkboxes.forEach((item) => {
        if (item !== name) item.checked = false;
      });
    }
  };

  function handleClick(checkbox) {
    if (typeof window !== "undefined") {
      queryParams = new URLSearchParams(window.location.search);
    }
    const checkboxes = document.getElementsByName(checkbox.name);

    checkboxes.forEach((item) => {
      if (item !== checkbox) item.checked = false;
    });
    if (checkbox.checked === false) {
      queryParams.delete(checkbox.name);
    } else {
      if (queryParams.has(checkbox.name)) {
        queryParams.set(checkbox.name, checkbox.value);
      } else {
        queryParams.append(checkbox.name, checkbox.value);
      }
    }
    const path = window.location.pathname + "?" + queryParams.toString();
    router.push(path);
  }

  function checkHandler(checkBoxType, checkBoxValue) {
    if (typeof window !== "undefined") {
      queryParams = new URLSearchParams(window.location.search);

      const value = queryParams.get(checkBoxType);
      if (checkBoxValue === value) return true;
      return false;
    }
  }

  return (
    <>
      <div className="lg:hidden">
        <Sheet>
          <SheetTrigger className="border border-brand-light bg-white flex items-center gap-2 p-2 px-3 text-brand-navy font-medium hover:border-brand-sky hover:text-brand-sky transition-colors shadow-brand-sm">
            Filters: <Filter size={20} />
          </SheetTrigger>
          <SheetContent>
            <SheetHeader>
              <SheetTitle className="text-base text-brand-navy">
                REFINE YOUR RESULTS
              </SheetTitle>
            </SheetHeader>
            <ul>
              {schoolClasses?.map((item, index) => {
                return (
                  <li key={index}>
                    <label className="flex items-center border-b border-brand-light py-3">
                      <input
                        name="class"
                        type="checkbox"
                        value={item}
                        className="h-4 w-4 accent-brand-sky"
                        defaultChecked={checkHandler("class", item)}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <span className="ml-2 cursor-pointer text-foreground capitalize">
                        {item}
                      </span>
                    </label>
                  </li>
                );
              })}
            </ul>
          </SheetContent>
        </Sheet>
      </div>
      <Card className="hidden lg:flex w-56 min-w-[224px] flex-col border-brand-light shadow-brand-sm overflow-hidden">
        <CardHeader className="bg-brand-light/50">
          <CardTitle className="text-base text-brand-navy">
            REFINE YOUR RESULTS
          </CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-2 px-4">
          <ul>
            {schoolClasses?.map((item, index) => {
              return (
                <li key={index}>
                  <label className="flex items-center border-b border-brand-light py-3">
                    <input
                      name="class"
                      type="checkbox"
                      value={item}
                      className="h-4 w-4 accent-brand-sky"
                      defaultChecked={checkHandler("class", item)}
                      onClick={(e) => handleClick(e.target)}
                    />
                    <span className="ml-2 cursor-pointer text-foreground capitalize">
                      {item}
                    </span>
                  </label>
                </li>
              );
            })}
          </ul>
        </CardContent>
      </Card>
    </>
  );
};

export default Filters;